
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 43.778 56.002"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M14.113 19.252a1.75 1.75 0 01-1.735-1.534 15.793 15.793 0 01-.12-1.969 15.283 15.283 0 01.3-2.958 1.75 1.75 0 113.431.686 11.888 11.888 0 00-.227 2.112 1.7 1.7 0 01.007.175 12.467 12.467 0 00.086 1.532 1.75 1.75 0 01-1.527 1.943 1.714 1.714 0 01-.215.013z"}}),_c('path',{staticClass:"a",attrs:{"d":"M10.492 31.502a10.557 10.557 0 01-4.532-1.03 10.491 10.491 0 017.1-19.632 15.75 15.75 0 1117.342 20.48 1.75 1.75 0 11-.527-3.459 12.25 12.25 0 10-13.884-14.4 1.75 1.75 0 01-2.478 1.251 6.988 6.988 0 10-6.042 12.6 7.409 7.409 0 003.042.69h3.5a1.75 1.75 0 010 3.5h-3.521z"}}),_c('path',{staticClass:"a",attrs:{"d":"M15.765 56.002a1.75 1.75 0 01-1.75-1.75v-8.75h-3.139a2.6 2.6 0 01-1.856-.771 2.625 2.625 0 010-3.708l12.508-12.508a1.749 1.749 0 012.985 1.237v8.75h3.136a2.636 2.636 0 011.858.772 2.623 2.623 0 010 3.708L17.003 55.489a1.751 1.751 0 01-1.238.513zm-2.775-14h2.775a1.75 1.75 0 011.75 1.75v6.274l8.023-8.024h-2.773a1.75 1.75 0 01-1.75-1.75v-6.275z"}})])
          )
        }
      }
    